import {
  SET_NAVBAR_HOME_FOOTER,
  SET_NAVBAR_CARRITO_FOOTER,
  SET_NAVBAR_OFERTAS_FOOTER,
  SET_NAVBAR_MENU_FOOTER,
} from "../types";

const initialState = {
  setHome: true,
  setCarrito: false,
  setOfertas: false,
  setMenu: false,
};

const storageNavbar = JSON.parse(localStorage.getItem("navbar_footer"));

const navBarReducer = (
  state = storageNavbar ?? initialState,
  { type, payload }
) => {
  switch (type) {
    case SET_NAVBAR_HOME_FOOTER:
      return {
        ...state,
        setHome: payload,
      };
    case SET_NAVBAR_CARRITO_FOOTER:
      return {
        ...state,
        setCarrito: payload,
      };
    case SET_NAVBAR_OFERTAS_FOOTER:
      return {
        ...state,
        setOfertas: payload,
      };
    case SET_NAVBAR_MENU_FOOTER:
      return {
        ...state,
        setMenu: payload,
      };

    default:
      return state;
  }
};

export default navBarReducer;
